import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "/app/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/app/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _classPrivateFieldInitSpec from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/app/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
// Copyright 2017-2022 @polkadot/types-codec authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assert, compactFromU8aLim, compactToU8a, isString, u8aConcatStrict, u8aToU8a } from '@polkadot/util';
import { Raw } from "../native/Raw.js";
/** @internal */

function decodeBitVecU8a(value) {
  if (!value || !value.length) {
    return [0, new Uint8Array()];
  } // handle all other Uint8Array inputs, these do have a length prefix which is the number of bits encoded


  var _compactFromU8aLim = compactFromU8aLim(value),
      _compactFromU8aLim2 = _slicedToArray(_compactFromU8aLim, 2),
      offset = _compactFromU8aLim2[0],
      length = _compactFromU8aLim2[1];

  var total = offset + Math.ceil(length / 8);
  assert(total <= value.length, function () {
    return "BitVec: required length less than remainder, expected at least ".concat(total, ", found ").concat(value.length);
  });
  return [length, value.subarray(offset, total)];
}
/** @internal */


function decodeBitVec(value) {
  if (Array.isArray(value) || isString(value)) {
    var u8a = u8aToU8a(value);
    return [u8a.length / 8, u8a];
  }

  return decodeBitVecU8a(value);
}
/**
 * @name BitVec
 * @description
 * A BitVec that represents an array of bits. The bits are however stored encoded. The difference between this
 * and a normal Bytes would be that the length prefix indicates the number of bits encoded, not the bytes
 */


var _decodedLength = /*#__PURE__*/new WeakMap();

var _isMsb = /*#__PURE__*/new WeakMap();

export var BitVec = /*#__PURE__*/function (_Raw) {
  _inherits(BitVec, _Raw);

  var _super = _createSuper(BitVec);

  // In lieu of having the Msb/Lsb identifiers passed through, we default to assuming
  // we are dealing with Lsb, which is the default (as of writing) BitVec format used
  // in the Polkadot code (this only affects the toHuman displays)
  function BitVec(registry, value) {
    var _this;

    var isMsb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, BitVec);

    var _decodeBitVec = decodeBitVec(value),
        _decodeBitVec2 = _slicedToArray(_decodeBitVec, 2),
        decodedLength = _decodeBitVec2[0],
        u8a = _decodeBitVec2[1];

    _this = _super.call(this, registry, u8a);

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _decodedLength, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(_assertThisInitialized(_this), _isMsb, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldSet(_assertThisInitialized(_this), _decodedLength, decodedLength);

    _classPrivateFieldSet(_assertThisInitialized(_this), _isMsb, isMsb);

    return _this;
  }
  /**
   * @description The length of the value when encoded as a Uint8Array
   */


  _createClass(BitVec, [{
    key: "encodedLength",
    get: function get() {
      return this.length + compactToU8a(_classPrivateFieldGet(this, _decodedLength)).length;
    }
    /**
     * @description Returns a breakdown of the hex encoding for this Codec
     */

  }, {
    key: "inspect",
    value: function inspect() {
      return {
        outer: [compactToU8a(_classPrivateFieldGet(this, _decodedLength)), _get(_getPrototypeOf(BitVec.prototype), "toU8a", this).call(this)]
      };
    }
  }, {
    key: "toHuman",
    value: function toHuman() {
      var _this2 = this;

      return "0b".concat(_toConsumableArray(this.toU8a(true)).map(function (d) {
        return "00000000".concat(d.toString(2)).slice(-8);
      }).map(function (s) {
        return _classPrivateFieldGet(_this2, _isMsb) ? s : s.split('').reverse().join('');
      }).join('_'));
    }
    /**
     * @description Returns the base runtime type name for this instance
     */

  }, {
    key: "toRawType",
    value: function toRawType() {
      return 'BitVec';
    }
    /**
     * @description Encodes the value as a Uint8Array as per the SCALE specifications
     * @param isBare true when the value has none of the type-specific prefixes (internal)
     */

  }, {
    key: "toU8a",
    value: function toU8a(isBare) {
      var bitVec = _get(_getPrototypeOf(BitVec.prototype), "toU8a", this).call(this);

      return isBare ? bitVec : u8aConcatStrict([compactToU8a(_classPrivateFieldGet(this, _decodedLength)), bitVec]);
    }
  }]);

  return BitVec;
}(Raw);